import {
  call,
  put,
  takeLatest,
  select
} from "redux-saga/effects";
import _ from "lodash";
import {
  authorizedRequest
} from "utils/api";
import {
  API_NOTES
} from "constants/apiRoutes";
import {
  dealUpdateSuccess
} from "store/state/deal";
import {
  fundUpdateSuccess
} from "store/state/fund";
import {
  quoteNewNote
} from "store/state/quote";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";

export const NOTE_UPDATE_REQUEST = "NOTE_UPDATE_REQUEST";

export const NOTE_LIST_REQUEST = "NOTE_LIST_REQUEST";

export const NOTE_CREATE_REQUEST = "NOTE_CREATE_REQUEST";
export const NOTE_CREATE_SUCCESS = "NOTE_CREATE_SUCCESS";
export const NOTE_CREATE_FAILURE = "NOTE_CREATE_FAILURE";

export const NOTE_DELETE_REQUEST = "NOTE_DELETE_REQUEST";

export const NOTE_OPEN_MODAL = "NOTE_OPEN_MODAL";
export const NOTE_CLOSE_MODAL = "NOTE_CLOSE_MODAL";

// TODO: I think this file needs deleted.
const initialState = {
  notes: [],
  modal: {
    model: null,
    modelId: null
  }
};

export default function noteReducer(state = initialState, action) {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case NOTE_OPEN_MODAL:
      return {
        ...state,
        modal: {
          model: payload.model,
          modelId: payload.modelId
        }
      };

    case NOTE_CLOSE_MODAL:
      return {
        ...state,
        modal: initialState.modal
      };

    default:
      return state;
  }
}

export const openNotes = (model, modelId) => ({
  type: NOTE_OPEN_MODAL,
  payload: {
    model,
    modelId
  }
});

export const closeNotes = () => ({
  type: NOTE_CLOSE_MODAL
});

export function createNote(payload) {
  return {
    type: NOTE_CREATE_REQUEST,
    payload
  };
}

export function updateNote(payload) {
  return {
    type: NOTE_UPDATE_REQUEST,
    payload
  };
}

export function deleteNote(payload) {
  return {
    type: NOTE_DELETE_REQUEST,
    payload
  };
}

export function listNotes({
  model,
  id
}) {
  return {
    type: NOTE_LIST_REQUEST,
    payload: {
      model,
      id
    }
  };
}

// Saga
function* createSaga({
  payload
}) {
  try {
    const {
      model,
      modelId
    } = payload.note;
    const response = yield call(authorizedRequest, API_NOTES, "POST", payload);
    switch (model) {
      case "deal":
        yield put(dealUpdateSuccess({
          deal: response.deal
        }));
        yield put({ type: NOTE_LIST_REQUEST,
          payload: {
            model,
            modelId
          } });
        break;

      case "fund":
        yield put(fundUpdateSuccess({
          fund: response.fund
        }));
        yield put({ type: NOTE_LIST_REQUEST,
          payload: {
            model,
            modelId
          } });
        break;

      case "quote":
        yield put(quoteNewNote({
          quote: response.quote
        }));
        yield put({ type: NOTE_LIST_REQUEST,
          payload: {
            model,
            modelId
          } });
        break;

      default:
        break;
    }
  } catch (error) {
    ToastError(error.message);
  }
}

function* updateSaga({
  payload
}) {
  try {
    const note = {
      note: {
        note: payload.note,
        isPrivate: payload.isPrivate
      }
    };
    const response = yield call(
      authorizedRequest,
      `/notes/${payload.id}`,
      "PUT",
      note
    );

    switch (response.note.model) {
      case "deal":
        yield put(dealUpdateSuccess({
          deal: response.deal
        }));
        break;

      case "fund":
        yield put(fundUpdateSuccess({
          fund: response.fund
        }));
        break;

      case "quote":
        yield put(quoteNewNote({
          quote: response.quote
        }));
        break;

      default:
        break;
    }
  } catch (error) {
    ToastError(error.message);
  }
}

function* deleteSaga({
  payload
}) {
  try {
    const response = yield call(
      authorizedRequest,
      `/notes/${payload.id}`,
      "DELETE"
    );

    switch (response.note.model) {
      case "deal":
        yield put(dealUpdateSuccess({
          deal: response.deal
        }));
        break;

      case "fund":
        yield put(fundUpdateSuccess({
          fund: response.fund
        }));
        break;

      case "quote":
        yield put(quoteNewNote({
          quote: response.quote
        }));
        break;

      default:
        break;
    }
  } catch (error) {
    ToastError(error.message);
  }
}

function* listSaga({
  payload: {
    model,
    id
  }
}) {
  try {
    const {
      notes
    } = yield call(
      authorizedRequest,
      `/notes?model=${model}&modelId=${id}`
    );
    switch (model) {
      case "deal":
      {
        const deal = yield select(state => state.deal[id]);
        const dealWithNotes = {
          deal: {
            ...deal,
            notes
          }
        };
        break;
      }
      case "fund":
      {
        const fund = yield select(state => state.fund.funds[id]);
        const fundWithNotes = {
          fund: {
            ...fund,
            notes
          }
        };
        break;
      }
      /*
       * case "quote":
       *   yield put(quoteUpdateSuccess({ quote: { id, notes } }));
       *   break;
       */
      default:
        break;
    }
  } catch (error) {
    yield ToastError(error.message);
  }
}

export function* noteSaga() {
  yield takeLatest(NOTE_CREATE_REQUEST, createSaga);
  yield takeLatest(NOTE_UPDATE_REQUEST, updateSaga);
  yield takeLatest(NOTE_DELETE_REQUEST, deleteSaga);
  yield takeLatest(NOTE_LIST_REQUEST, listSaga);
}
